import { create } from "zustand";

// Your type definitions
type leaderboardUserData = {
  challengeId: string;
  userChallengeData: {
    inGameUserName: string;
    lastPointsDate: number;
    points: number;
    pointsType: string;
    rank: number;
    tenantId: string;
  };
  userId: string;
};

type Zones = {
  name: string;
  slug: string;
  // Add other fields you use for a zone here
};

interface LeaderboardState {
  leaderboard: {
    [key: string]: leaderboardUserData[];
  };
  setLeaderboard: (leaderboard: {
    [key: string]: leaderboardUserData[];
  }) => void;
  getLeaderboardByKey: (key: string) => leaderboardUserData[] | undefined;
  addLeaderboard: (key: string, userData: leaderboardUserData) => void;
}

// Zustand store
export const useLeaderboardStore = create<LeaderboardState>((set, get) => ({
  leaderboard: {},

  setLeaderboard: (leaderboard) => set({ leaderboard }),

  getLeaderboardByKey: (key) => {
    return get().leaderboard[key];
  },

  addLeaderboard: (key, userData: any) => {
    const { leaderboard } = get();
    const existing = leaderboard[key] || [];
    set({
      leaderboard: {
        ...leaderboard,
        [key]: userData,
      },
    });
  },
}));
